import "react-app-polyfill/ie11";
import "react-app-polyfill/stable";

import { createRoot } from "react-dom/client";

import App from "./App";

const root = createRoot(document.getElementById("root"));
root.render(<App />);
